module.exports = __webpack_public_path__ + "img/star_product_1.4beb0435.png";